module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAWlBMVEUAAAAnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrb///88fL3G2exBf780d7vm7vfg6vTc6PTQ4PDK2+1EgsD1+PzT4fCxy+VRisQvdLkUUqcfAAAADXRSTlMA4VSqBtqJW/rzlPYHZ6p1OwAAAIxJREFUGNNtkNkOgyAQRWdD0JZFbavd/v83jaMSopwXck8gcxlQhBhda5gEMmT8jqHDNb6gye5iyZ8gAMGzRAHrL1jgIg3ptx4MWLhPmPQ93DT3378fXuEZ1+CgVZlCiuo2ababY3iHR9zHH4PmUZ3CudI89blSrfy99s3qQpSudF11yRmxjM4hW9G4ABUWEAmzsgsGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_save_active.png
// module id = ZD05
// module chunks = 9